module.exports = __webpack_public_path__ + "img/clere-logo-grey.e61e1826.png";